import { NgStyle } from '@angular/common';
import { Component, HostBinding, inject } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { FilterCombinationResponse } from '@api-response-types/filter-combination.response';
import { ColoredChip } from '@core/types/chip';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { AppliedFilterChipsService } from 'demand-forecasting/services/applied-filter-chips.service';
import { selectSelectedFilterCombinationsFromUrl } from 'demand-forecasting/store/filter/filter.selectors';
import { convertFiltersRecordToMap } from '@api-types/helper/helper';

@Component({
  imports: [TranslateModule, MatDividerModule, MatChipsModule, NgStyle],
  selector: 'pm-selected-filter-combination-chips',
  templateUrl: './selected-filter-combination-chips.html',
})
export class SelectedFilterCombinationChipsComponent {
  readonly GAP_BETWEEN_CHIPS = 8;
  readonly MAX_NUM_OF_SHOWN_APPLIED_FILTERS = 60;

  private readonly store = inject(Store);
  protected appliedFilterChipsService = inject(AppliedFilterChipsService);

  protected selectedFilterCombinations = this.store.selectSignal(
    selectSelectedFilterCombinationsFromUrl('filterCombinationIds'),
  );

  // note: the class is used to hide the component if there are no selected filter combinations. this is important to not get a gap in the ui
  @HostBinding('class')
  get classes() {
    return this.selectedFilterCombinations().length === 0 ? 'hidden' : '';
  }
  protected mapFilterCombinationFiltersToChips(
    filters: FilterCombinationResponse['appliedFilters'],
  ): {
    chips: ColoredChip[];
    numOfLeftOverFilters: number;
  } {
    const res = this.appliedFilterChipsService.computeAppliedFilterChips(
      convertFiltersRecordToMap(filters),
    )();

    if (res.length > this.MAX_NUM_OF_SHOWN_APPLIED_FILTERS) {
      // there are more filters than we can show -> show only first MAX_NUM_OF_SHOWN_APPLIED_FILTERS
      // return the number of left over filters
      return {
        chips: res.slice(0, this.MAX_NUM_OF_SHOWN_APPLIED_FILTERS),
        numOfLeftOverFilters:
          res.length - this.MAX_NUM_OF_SHOWN_APPLIED_FILTERS,
      };
    }
    // case: all filters fit into the view
    return {
      chips: res,
      numOfLeftOverFilters: 0,
    };
  }
}
